// Which pages sit in the staff workspace: the left sidebar with the page on a
// white panel (FECOA-2174). Participant pages, sign-in pages, the landing page
// and the sponsor picker keep the top header instead.

const PARTICIPANT_SECTIONS = ['participant-dashboard', 'survey-taking', 'faq'];
const NO_MENU_SECTIONS = ['login', 'forgot-password', 'register', 'assessment', 'home', 'sponsor-selector'];

const firstSegment = (pathname = '') => pathname.split('/').filter(Boolean)[0];

export const isParticipantFlowPath = (pathname, userType) =>
  userType === 'participant' || PARTICIPANT_SECTIONS.includes(firstSegment(pathname));

export const usesStaffShell = ({ isAuthenticated, userType, pathname }) => {
  if (!isAuthenticated) return false;
  const section = firstSegment(pathname);
  if (!section || NO_MENU_SECTIONS.includes(section)) return false;
  return !isParticipantFlowPath(pathname, userType);
};

// Page name shown in the top bar when a page has no breadcrumb trail.
const SECTION_LABELS = {
  studies: 'Studies',
  studybuilder: 'Study Builder',
  'assessment-builder': 'Assessment Builder',
  'study-promotion': 'Study Promotion',
  notifications: 'Notifications',
  profile: 'Profile',
  development: 'Development',
  'user-management': 'User Management',
  'review-history': 'Review History',
  'api-key': 'API Keys',
  superadmin: 'SuperAdmin Panel',
};

export const sectionLabelFor = (pathname) => {
  const section = firstSegment(pathname);
  if (!section) return '';
  if (SECTION_LABELS[section]) return SECTION_LABELS[section];
  return section
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
